module.exports = __webpack_public_path__ + "static/img/8.92f0174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/list/8.png
// module id = XYRd
// module chunks = 1